import { LocationAddress } from "../../Location/Dto/LocationAddressModel";

export enum VendorType {
  Printing = "Printing",
  Shipment = "Shipment",
}

export interface Vendor {
  id: string;
  name: string;
  type: VendorType;
  contactPerson?: string | null;
  phone?: string | null;
  email?: string | null;
  address?: LocationAddress | string | null;
  note?: string | null;
  createdAt?: string;
  updatedAt?: string;
}
